import { render, staticRenderFns } from "./AvailableInventory.vue?vue&type=template&id=67f39a95&scoped=true"
import script from "./AvailableInventory.vue?vue&type=script&lang=js"
export * from "./AvailableInventory.vue?vue&type=script&lang=js"
import style0 from "./AvailableInventory.vue?vue&type=style&index=0&id=67f39a95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f39a95",
  null
  
)

export default component.exports